import { ArrowDownToLine } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import type { ReconciliationFilter } from './reconciliationHelpers';

type ReconciliationFilterBarProps = {
  filter: ReconciliationFilter;
  problemsCount: number;
  allCount: number;
  onFilterChange: (filter: ReconciliationFilter) => void;
  showJumpToFirstProblem: boolean;
  onJumpToFirstProblem: () => void;
};

const TABS: { key: ReconciliationFilter; label: (count: number) => string }[] = [
  { key: 'problems', label: (count) => `Problems (${count})` },
  { key: 'all', label: (count) => `All rows (${count})` },
];

export const ReconciliationFilterBar = ({
  filter,
  problemsCount,
  allCount,
  onFilterChange,
  showJumpToFirstProblem,
  onJumpToFirstProblem,
}: ReconciliationFilterBarProps) => (
  <div className="flex items-center justify-between gap-4 border-y border-gray-200 bg-gray-50 px-6 py-2.5">
    <div className="inline-flex rounded-lg bg-gray-200/70 p-0.5" role="tablist" aria-label="Row filter">
      {TABS.map((tab) => {
        const count = tab.key === 'problems' ? problemsCount : allCount;
        const active = filter === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active}
            aria-expanded={active}
            onClick={() => onFilterChange(tab.key)}
            className={`relative rounded-md px-3 py-1.5 text-sm font-medium ${active ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600'}`}
          >
            {tab.label(count)}
          </button>
        );
      })}
    </div>
    {showJumpToFirstProblem && (
      <Button variant="outline" size="sm" onClick={onJumpToFirstProblem}>
        <ArrowDownToLine className="mr-1.5 h-3.5 w-3.5" aria-hidden />
        Jump to first problem
      </Button>
    )}
  </div>
);
